(() => {
  'use strict';
  function joinSections() {
    const roots = [...document.querySelectorAll('.nordic-flow')];
    roots.forEach((root, index) => {
      const previous = roots[index - 1];
      root.style.setProperty('--flow-from', previous ? getComputedStyle(previous).getPropertyValue('--flow-bg').trim() : 'transparent');
    });
  }
  joinSections();
  if (customElements.get('nordic-hero-video')) return;
  document.addEventListener('shopify:section:load', joinSections);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(joinSections));
  document.addEventListener('shopify:section:reorder', joinSections);
  class NordicHeroVideo extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('#nordic-motionToggle');
      if (!this.video || !this.button) return;
      this.lifecycle = new AbortController();
      const on = (el, event, callback) => el.addEventListener(event, callback, {signal: this.lifecycle.signal});
      this.inView = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.masterObserver = new MutationObserver(() => this.playback());
      this.masterObserver.observe(this.button, {attributes: true, attributeFilter: ['aria-pressed']});
      this.visibility = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.playback();
      }, {threshold: .1});
      this.visibility.observe(this);
      on(document, 'visibilitychange', () => this.playback());
      on(this.video, 'loadeddata', () => this.playback());
      on(this.video, 'error', () => { this.video.hidden = true; });
      on(this.reduced, 'change', () => this.playback());
      on(window, 'pagehide', () => this.video.pause());
      on(window, 'pageshow', () => this.playback());
      this.playback();
    }
    playback() {
      if (!this.lifecycle) return;
      const root = this.closest('.femieko-nordic');
      const paused = this.button.getAttribute('aria-pressed') === 'true' || (this.reduced.matches && !root.classList.contains('nordic-enhanced'));
      this.button.querySelector('path').setAttribute('d', paused ? 'm8 5 11 7-11 7Z' : 'M9 5v14M15 5v14');
      if (this.inView && !document.hidden && !paused) this.video.play().catch(() => {});
      else this.video.pause();
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = null;
      this.video?.pause();
      this.masterObserver?.disconnect();
      this.visibility?.disconnect();
    }
  }
  customElements.define('nordic-hero-video', NordicHeroVideo);
})();
